(() => {
  if (window.__weSiteEnergyLabelInit) return;
  window.__weSiteEnergyLabelInit = true;

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-energy-label-open]');
    if (openBtn) {
      event.preventDefault();
      event.stopPropagation();
      const dialogId = openBtn.getAttribute('aria-controls');
      const dialog = dialogId && document.getElementById(dialogId);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const closeBtn = event.target.closest('[data-energy-label-close]');
    if (closeBtn) {
      const closeDialog = closeBtn.closest('dialog');
      if (closeDialog) closeDialog.close();
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      if (!event.target.matches?.('dialog.we-site-energy-label__dialog')) return;
      const id = event.target.id;
      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
    },
    true
  );
})();
